import { IconButton, Tooltip } from "@material-ui/core"
import { useDispatch } from "react-redux"
import LocationCityIcon from '@material-ui/icons/LocationCity';
import { openModalCiudadesPaqueteTerrestre } from "../../../ducks/proveedorTerrestreDuck"

const BCiudades = (props) => {
    const { paquete } = props
    const dispatch = useDispatch()
    
    const handleClick = () => {
        dispatch(openModalCiudadesPaqueteTerrestre({
          paquete
        }))
    }
    
    return (
        <Tooltip title="Ciudades">
            <IconButton aria-label="Declinar solicitud" onClick={handleClick}>
                <LocationCityIcon color="primary" /> 
            </IconButton>
        </Tooltip>
    )
}

export default BCiudades